<template>
  <div class="awardMain">
    <small-loading v-if="loading" />
    <header>
      <NavBar :title="lang('冲单激励')"></NavBar>
    </header>
    <div class="box">
      <card :info="info" />
      <div class="list">
        <div class="situation">
          <p class="title">{{ lang('上月奖励排行') }}</p>
          <p class="date">{{ lastMonth }}</p>
        </div>
        <div class="titleBox">
          <p class="rank">{{ lang('排名') }}</p>
          <p class="name">{{ lang('站点名称') }}</p>
        </div>
        <Separate
          :style="{ height: '1px', background: 'rgba(220,222,225,0.51)' }"
        />
        <RankLine :list="list" />
        <NoData v-if="list.length === 0 && !loading" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import NavBar from '@/components/NavBar.vue'
import lang from '@/langs'
import Card from '@/views/award/component/card.vue'
import Separate from '@/components/separate.vue'
import { ref } from 'vue'
import RankLine from '@/views/award/component/rankLine.vue'
import { getInspire, getSort } from '@/api/requests/award'
import { showToast } from 'vant'
import { getSortResp } from '@/model/award/award'
import dayjs from 'dayjs'
import NoData from '@/components/NoData.vue'
import SmallLoading from '@/components/smallLoading.vue'
import { handleApiError } from '@/api/http'
const list = ref([])
const info = ref()
const loading = ref(true)
const lastMonth = dayjs().subtract(1, 'month').format('YYYY-MM')
const getCollection = () => {
  loading.value = true
  getInspire()
    .then((value) => {
      if (value.code === 1) {
        info.value = value.data
      } else {
        showToast(
          lang(handleApiError(value.code)) ||
            value?.msg ||
            ' Service exception, please try again later'
        )
      }
    })
    .finally(() => {
      setTimeout(() => {
        loading.value = false
      }, 200)
    })
}
const getList = () => {
  getSort().then((value) => {
    if (value.code === 1) {
      const temp = []
      value.data &&
        value.data.map((e: getSortResp) => {
          temp.push({ name: e.stationName, value: e.num })
        })
      list.value = [...temp]
    } else {
      showToast(
        lang(handleApiError(value.code)) ||
          value?.msg ||
          ' Service exception, please try again later'
      )
    }
  })
}
getCollection()
getList()
</script>

<style scoped lang="less">
.awardMain {
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  .box {
    flex: 1;
    overflow: scroll;
    .list {
      border-radius: 5.78px;
      background: rgba(255, 255, 255, 1);
      padding: 20px 12px;
      padding-bottom: 0;
      margin: 10px;
      .situation {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .title {
          font-size: 17px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
        }
        .date {
          font-size: 13px;
          color: rgba(60, 60, 60, 1);
        }
      }
      .titleBox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 37px;
        margin-bottom: 21px;
        .rank {
          font-size: 15px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          width: 50px;
          text-align: center;
          //padding-left: 8px;
        }
        .name {
          font-size: 15px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          flex: 1;
          text-align: center;
        }
      }
    }
  }
}
</style>
